module.exports = __webpack_public_path__ + "img/sparking-change-flashlight.3943558b.png";